import { useQuery } from '@tanstack/react-query';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { SuggestedActionsResponse } from 'router/subrouters/DataRoom/models/Dashboard';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

export const SUGGESTED_ACTIONS_QUERY_KEY = 'data-room-suggested-actions';

type UseSuggestedActionsQueryProps = {
  dataRoomId?: string;
  doesntHaveAccess?: boolean;
};

export default function useSuggestedActionsQuery({
  dataRoomId,
  doesntHaveAccess,
}: UseSuggestedActionsQueryProps) {
  const getMixpanelProps = useGetMixpanelProps();

  const query = useQuery<SuggestedActionsResponse>({
    queryKey: [SUGGESTED_ACTIONS_QUERY_KEY, { dataRoomId }],
    queryFn: async () => {
      const { data } = await dataRoomApi.room.getSuggestedActions(dataRoomId);

      return data;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
    enabled: !!dataRoomId && !doesntHaveAccess,
  });

  useInvalidateQueryOnUnmount(SUGGESTED_ACTIONS_QUERY_KEY);

  return query;
}
